import { connect } from 'react-redux';

import Results from './results';

const mapStateToProps = state => ({
  searchQuery: state.ux.searchQuery,
  tvguideLoading: state.ux.load.searchTvguide,
  catchupLoading: state.ux.load.searchCatchup,
  tvguidePrograms: state.programs.filter(p => {
    return p.type === 'tvguide' && p.now_next == 'now';
  }),
  catchupPrograms: state.programs.filter(p => {
    return p.type === 'recommendations';
  }),
  tvguideResults: state.results.filter(p => p.type == 'tvguide'),
  catchupResults: state.results.filter(p => p.type == 'recommendations'),
});

export default connect(mapStateToProps, null)(Results);
